import createOmnitechApp from './create-omnitech-app'

export default createOmnitechApp
